import api from "api";
import { useMutation } from "react-query";
import { useId } from "utils/hooks";

const OP = "PATCH /therapists/{id}";

export type Vars = {
  therapist_type: string;
};

const useChangeTherapistType = () => {
  const id = useId();

  return useMutation(({ therapist_type }: Vars) =>
    api.parse(OP, {
      params: [id],
      data: {
        therapist_type,
      },
    })
  );
};

export default useChangeTherapistType;
